export const shiftCacheKeys = {
  action: {
    getUnassigned: queryParams =>
      ['get_unassigned_shifts', queryParams] as const,
    getAllUnassigned: () => ['get_unassigned_shifts']
  }
}
